/* eslint-disable @typescript-eslint/ban-ts-comment */
import { Dispatch, useCallback, useEffect, useRef } from 'react'
import { UiState } from '../../../types'
import {
  validateEmail,
  validateName,
  validatePhone,
} from '../../../utils/Validate'

export const useHandleChangeStoreName = (
  state: UiState,
  setState: Dispatch<React.SetStateAction<UiState>>
) => {
  return useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) =>
      setState({
        ...state,
        storeName: {
          value: e.target.value,
          errors: validateName(e.target.value),
        },
      }),
    [setState, state]
  )
}

export const useHandleChangeLastName = (
  state: UiState,
  setState: Dispatch<React.SetStateAction<UiState>>
) => {
  return useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) =>
      setState({
        ...state,
        lastName: {
          value: e.target.value,
          errors: validateName(e.target.value),
        },
      }),
    [setState, state]
  )
}

export const useHandleChangeFirstName = (
  state: UiState,
  setState: Dispatch<React.SetStateAction<UiState>>
) => {
  return useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) =>
      setState({
        ...state,
        firstName: {
          value: e.target.value,
          errors: validateName(e.target.value),
        },
      }),
    [setState, state]
  )
}

export const useHandleChangeEmail = (
  state: UiState,
  setState: Dispatch<React.SetStateAction<UiState>>
) => {
  return useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) =>
      setState({
        ...state,
        email: {
          value: e.target.value,
          shouldCheckFormat: state.email.shouldCheckFormat,
          errors: validateEmail(e.target.value, state.email.shouldCheckFormat),
        },
      }),
    [setState, state]
  )
}

export const useHandleChangePhone = (
  state: UiState,
  setState: Dispatch<React.SetStateAction<UiState>>
) => {
  return useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) =>
      setState({
        ...state,
        phone: {
          value: e.target.value,
          errors: validatePhone(e.target.value),
        },
      }),
    [setState, state]
  )
}

// OESのフォームの内容をMarketoのフォームに反映させる
// TODO: テスト実装
export const useChange = (
  marketoFormRef: React.RefObject<HTMLFormElement>,
  state: UiState
) => {
  const storeNameRef = useRef<HTMLInputElement>(null)
  const emailRef = useRef<HTMLInputElement>(null)
  const lastNameRef = useRef<HTMLInputElement>(null)
  const firstNameRef = useRef<HTMLInputElement>(null)
  const phoneRef = useRef<HTMLInputElement>(null)
  useEffect(() => {
    // @ts-ignore
    storeNameRef.current =
      marketoFormRef.current?.querySelector('input#storeName')
    if (storeNameRef.current instanceof HTMLInputElement) {
      storeNameRef.current.value = state.storeName.value
    }
    // @ts-ignore
    lastNameRef.current =
      marketoFormRef.current?.querySelector('input#LastName')
    if (lastNameRef.current instanceof HTMLInputElement) {
      lastNameRef.current.value = state.lastName.value
    }
    // @ts-ignore
    firstNameRef.current =
      marketoFormRef.current?.querySelector('input#FirstName')
    if (firstNameRef.current instanceof HTMLInputElement) {
      firstNameRef.current.value = state.firstName.value
    }
    // @ts-ignore
    emailRef.current = marketoFormRef.current?.querySelector('input#Email')
    if (emailRef.current instanceof HTMLInputElement) {
      emailRef.current.value = state.email.value
    }
    // @ts-ignore
    phoneRef.current = marketoFormRef.current?.querySelector('input#Phone')
    if (phoneRef.current instanceof HTMLInputElement) {
      phoneRef.current.value = state.phone.value
    }
  }, [marketoFormRef, state])
}
